import { runQuery } from '../../fetchUtils'
const deleteAssignments = (callbacks, vars) => {
	const query = `
    mutation DeleteAssignments($ids: [ID!]!){
      deleteAssignments(ids:$ids) {
        deletionCount
        deletedAssignments{
          id
          studentId
          sectionAssignmentId
          userId
          questId
        }
        errors
      }
    }`
	runQuery(query, vars, callbacks)
}

const upsertAssignments = (callbacks, vars) => {
	const query = `
    mutation UpsertAssignments($sectionIds: [ID!], $studentIds: [ID!], $userAssignment: Boolean, $questId: ID, $sequenceId: ID, $timestamps: [String!]!, $resolutions: [Boolean!]){
      upsertAssignments(sectionIds: $sectionIds, studentIds: $studentIds, userAssignment: $userAssignment, questId: $questId, storylineId: $sequenceId, timestamps: $timestamps, resolutions: $resolutions){
        conflict
        errors
        formattedGroupInfo
        assignments{
          id
          sectionAssignmentId
          studentId
          userId
          questId
        }
      }
  }`
	runQuery(query, vars, callbacks)
}

export default { upsertAssignments, deleteAssignments }
